var _rect, _path, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_896",
    "data-name": "Ret\\xE2ngulo 896",
    width: 60,
    height: 60,
    rx: 10,
    fill: "#ffaa8c",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Work",
    "data-name": "Iconly Two-tone Work",
    transform: "translate(14.332 14.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Work-8",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1-150",
    "data-name": "Stroke 1-150",
    transform: "translate(0.095 22.692)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_353",
    "data-name": "Caminho 353",
    d: "M766.3,562.635a6.27,6.27,0,0,1-4.827-2.338,7.731,7.731,0,0,1-1.634-4.32c-.054-.918-.293-3.838-.293-3.839l2.527-.2s.242,2.96.3,3.894a5.178,5.178,0,0,0,1.088,2.892,3.763,3.763,0,0,0,3.159,1.367l19.485,0a3.762,3.762,0,0,0,3.258-1.382,5.172,5.172,0,0,0,1.072-2.874c.063-.939.3-3.894.3-3.894l2.527.2s-.237,2.926-.3,3.85a7.722,7.722,0,0,1-1.615,4.289,6.322,6.322,0,0,1-5.331,2.339l-19.313,0C766.576,562.63,766.439,562.635,766.3,562.635Z",
    transform: "translate(-759.55 -551.933)",
    fill: "#ffaa8c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3-124",
    "data-name": "Stroke 3-124",
    transform: "translate(9.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_354",
    "data-name": "Caminho 354",
    d: "M778.348,545.416a1.268,1.268,0,0,1-1.269-1.269v-.628a2.469,2.469,0,0,0-2.466-2.466h-4.371a2.471,2.471,0,0,0-2.466,2.466v.628a1.269,1.269,0,1,1-2.537,0v-.628a5.009,5.009,0,0,1,5-5h4.376a5.009,5.009,0,0,1,5,5v.633A1.268,1.268,0,0,1,778.348,545.416Z",
    transform: "translate(-765.239 -538.517)",
    fill: "#ffaa8c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_5-66",
    "data-name": "Stroke 5-66",
    transform: "translate(15.635 21.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_355",
    "data-name": "Caminho 355",
    d: "M770.007,555.877a1.269,1.269,0,0,1-1.269-1.269V552.42a1.269,1.269,0,1,1,2.537,0v2.189A1.269,1.269,0,0,1,770.007,555.877Z",
    transform: "translate(-768.738 -551.151)",
    fill: "#ffaa8c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_7-31",
    "data-name": "Stroke 7-31",
    transform: "translate(0 4.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_356",
    "data-name": "Caminho 356",
    d: "M780.588,558.918a1.268,1.268,0,0,1-1.223-.944,3.1,3.1,0,0,0-5.983-.012,1.264,1.264,0,0,1-1.394.927,29.089,29.089,0,0,1-11.919-4.421,1.272,1.272,0,0,1-.575-1.064v-5.876a6.445,6.445,0,0,1,6.441-6.431h20.93a6.442,6.442,0,0,1,6.439,6.446V553.4a1.271,1.271,0,0,1-.575,1.062,29.051,29.051,0,0,1-11.972,4.44A1.141,1.141,0,0,1,780.588,558.918Zm-4.213-5.783a5.627,5.627,0,0,1,5.032,3.107,26.564,26.564,0,0,0,9.36-3.535V547.54a3.9,3.9,0,0,0-3.883-3.905H765.938a3.9,3.9,0,0,0-3.907,3.9l-1.269.008h1.269v5.166a26.567,26.567,0,0,0,9.313,3.52A5.659,5.659,0,0,1,776.374,553.135Z",
    transform: "translate(-759.494 -541.097)",
    fill: "#ffaa8c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOrder);
export default __webpack_public_path__ + "static/media/service-order.487e53b650b940ca3acc2f5b266c2e84.svg";
export { ForwardRef as ReactComponent };